<qpoint-map #qpointMap
    [enableFullscreenControl]="true"
    [zoom]="19"
    [setZoomLevelOnFitBounds]="true"
    [stopFitToBoundsOnManualInteraction]="true"
    [zoomPosition]="zoomPosition"
    [minZoom]="0"
    [minZoomToShowLabels]="12"
    [gestureHandling]="'greedy'"
    (polygonClick)="onPolygonClick($event)"
    (mapLoaded)="onMapLoaded($event)">
    <qpoint-map-polygons [polygons]="polygons()"></qpoint-map-polygons>
</qpoint-map>